import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

// Components
import Navbar from "../containers/Home/Navbar";
import BackToEditor from "../components/UI/BackToEditor";

//
import useAuth from "../utils/hooks/useAuth";
import UserMiddlewares from "../store/middlewares/UserMiddlewares";

const Delete = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useAuth({
    authRequired: true,
    redirectTo: "/login",
  });

  const deleteAccountHandler = () => {
    dispatch(UserMiddlewares.deleteAccount());
  };

  return (
    <>
      <Navbar />
      <BackToEditor />
      <main className="bg-accent page content px-0 px-md-3">
        <div className="container-fluid">
          <div className="row">
            <div className="col m-0 m-md-5 p-0 p-md-4">
              <div className="form-wrapper my-5">
                <h3 className="text-start">{t("delete.title")}</h3>
                <p>{t("delete.warningText")}</p>
                <button
                  className="btn btn-danger"
                  onClick={deleteAccountHandler}
                >
                  {t("delete.buttonText")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Delete;
